import * as graphql from 'generated/graphql';
import useLocalize from 'packages/kakapo-ui-application/hooks/useLocalize';
import { Card, LoadingOverlay, Modal, Progress, ScrollArea, TextInput } from '@mantine/core';
import { Subheading } from '@treams/treams-ui';
import { useState } from 'react';
import styles from './AddGoalModal.module.css';

function GoalCard({ goal, onClick }: { goal: graphql.Goal; onClick?: () => void }) {
	const { localize } = useLocalize();

	return (
		<Card onClick={onClick} shadow="xs" padding="lg" withBorder mb="10" className={styles.goalCard}>
			<Subheading flexGrow={1} flexShrink={1} mb="10px">
				{localize(goal.title).text}
			</Subheading>
			<Progress value={goal.progress * 100} />
		</Card>
	);
}

export default function AddGoalModal({
	onDismiss,
	onAddGoal,
	opened,
	selectedGoals,
	adding,
	user,
}: {
	user: graphql.User;
	opened: boolean;
	adding: boolean;
	onDismiss: () => void;
	onAddGoal: (goals: graphql.Goal) => void;
	selectedGoals: graphql.Goal[];
}) {
	const { localize } = useLocalize();
	const [filter, setFilter] = useState('');

	const goalsQuery = graphql.useIndividualGoalsQuery({
		variables: {
			id: user.id,
			status: graphql.GoalStatus.Active,
			last: 100,
		},
	});

	const goals = goalsQuery.data?.user.goalsV2.edges
		.map(({ node: goal }) => goal as graphql.Goal)
		.filter((goal) => !selectedGoals.find((selectedGoal) => selectedGoal.id === goal.id))
		.filter((goal) => localize(goal.title).text.toLowerCase().includes(filter.toLowerCase()));

	return (
		<Modal
			// @TODO: Translate title
			title={`Doel voor review voor ${user.firstName} toevoegen`}
			opened={opened}
			onClose={onDismiss}
			size="xl"
			scrollAreaComponent={ScrollArea.Autosize}
		>
			<Card padding="sm" mb="10" bg="lightgrey">
				<TextInput placeholder="Zoek doelen" onChange={(event) => setFilter(event.target.value)} />
			</Card>
			{goals &&
				goals.map((goal) => (
					<GoalCard onClick={() => onAddGoal(goal)} key={goal.id} goal={goal as graphql.Goal} />
				))}
			<LoadingOverlay visible={goalsQuery.loading || adding} />
		</Modal>
	);
}
